import { formLegacyTheme } from 'presentation/components/Form/FormLegacy.theme'

export const formTheme = {
  basStyles: {},
  variants: {
    ...formLegacyTheme,
  },
}
